var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 429,
    viewBox: "0 0 443 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000500601 217.128V215.566C-0.429965 98.0168 93.268 0.426361 221.045 0.000201689C348.821 -0.425957 442.376 94.9627 442.878 212.512V214.074C443.308 330.913 349.61 428.503 221.116 428.929C94.4876 429.355 0.574376 333.967 0.14391 217.128",
    fill: "#00E795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.443 96.1697C292.619 78.5994 283.543 62.6075 269.854 51.0807C256.165 39.5538 238.764 33.2514 220.793 33.3115C202.822 33.3715 185.465 39.7899 171.854 51.408C158.244 63.026 149.278 79.0782 146.573 96.667H145.856V106.966L146.573 318.98C146.573 320.898 146.573 322.815 146.573 324.804V325.301C146.607 334.936 148.59 344.466 152.404 353.33C156.218 362.194 161.787 370.212 168.781 376.911C175.775 383.611 184.054 388.856 193.129 392.337C202.203 395.818 211.89 397.465 221.618 397.18C231.42 397.388 241.165 395.657 250.283 392.089C259.4 388.521 267.707 383.187 274.716 376.401C281.725 369.614 287.296 361.51 291.101 352.565C294.906 343.62 296.87 334.013 296.878 324.307V323.738C296.878 321.963 296.878 320.187 296.878 318.483L296.16 105.9V96.1697H295.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.922 106.753V106.326C161.338 90.8944 167.793 76.2259 178.926 65.4167C190.059 54.6075 204.999 48.5035 220.592 48.3929C236.185 48.2823 251.212 54.1737 262.5 64.8238C273.788 75.474 280.455 90.0496 281.094 105.474V105.971C280.679 121.403 274.223 136.072 263.09 146.881C251.957 157.691 237.018 163.794 221.424 163.905C205.831 164.016 190.805 158.124 179.516 147.474C168.228 136.824 161.561 122.248 160.922 106.824",
    fill: "#00E795"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 443,
    height: 429,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.270d511b5ab34f71d743c14cd2ef4283.svg";
export { ForwardRef as ReactComponent };